import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Welcome } from './components/Welcome';
import { Dashboard } from './components/Dashboard';
import { UpdatesDialog } from './components/UpdatesDialog';
import { AdminDashboard } from './components/admin/AdminDashboard';
import { ErrorBoundary } from './components/ErrorBoundary';
import { LoadingSpinner } from './components/LoadingSpinner';
export function App() {
  const [userType, setUserType] = useState<'husband' | 'wife' | 'both' | 'engaged' | null>(() => {
    // Check if we have a saved user type in localStorage
    const savedUserType = localStorage.getItem('userType');
    if (savedUserType && ['husband', 'wife', 'both', 'engaged'].includes(savedUserType)) {
      return savedUserType as 'husband' | 'wife' | 'both' | 'engaged';
    }
    return null;
  });
  const [showUpdatesDialog, setShowUpdatesDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Simulate initial loading
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    // Check if this is the first time visiting after update
    const hasSeenUpdates = localStorage.getItem('hasSeenUpdatesV1.1');
    if (!hasSeenUpdates) {
      const updateTimer = setTimeout(() => {
        setShowUpdatesDialog(true);
      }, 1500);
      return () => {
        clearTimeout(timer);
        clearTimeout(updateTimer);
      };
    }
    return () => clearTimeout(timer);
  }, []);
  const handleCloseUpdatesDialog = () => {
    setShowUpdatesDialog(false);
    localStorage.setItem('hasSeenUpdatesV1.1', 'true');
  };
  const handleSelectUserType = (type: 'husband' | 'wife' | 'both' | 'engaged') => {
    setUserType(type);
    localStorage.setItem('userType', type);
  };
  const handleReset = () => {
    setUserType(null);
    localStorage.removeItem('userType');
  };
  if (isLoading) {
    return <div className="min-h-screen bg-amber-50 flex items-center justify-center" data-id="element-0">
        <div className="text-center" data-id="element-1">
          <LoadingSpinner size="lg" data-id="element-2" />
          <p className="mt-4 text-slate-600" data-id="element-3">جاري تحميل التطبيق...</p>
        </div>
      </div>;
  }
  return <ErrorBoundary data-id="element-4">
      <BrowserRouter data-id="element-5">
        <div className="min-h-screen bg-amber-50 text-slate-800 font-sans" data-id="element-6">
          <Routes data-id="element-7">
            <Route path="/admin/*" element={<AdminDashboard data-id="element-9" />} data-id="element-8" />
            <Route path="/" element={!userType ? <Welcome onSelectUserType={handleSelectUserType} data-id="element-11" /> : <Navigate to={`/${userType}`} replace data-id="element-12" />} data-id="element-10" />
            <Route path="/husband/*" element={userType ? <Dashboard userType="husband" onReset={handleReset} data-id="element-14" /> : <Navigate to="/" replace data-id="element-15" />} data-id="element-13" />
            <Route path="/wife/*" element={userType ? <Dashboard userType="wife" onReset={handleReset} data-id="element-17" /> : <Navigate to="/" replace data-id="element-18" />} data-id="element-16" />
            <Route path="/both/*" element={userType ? <Dashboard userType="both" onReset={handleReset} data-id="element-20" /> : <Navigate to="/" replace data-id="element-21" />} data-id="element-19" />
            <Route path="/engaged/*" element={userType ? <Dashboard userType="engaged" onReset={handleReset} data-id="element-23" /> : <Navigate to="/" replace data-id="element-24" />} data-id="element-22" />
            <Route path="*" element={<Navigate to="/" replace data-id="element-26" />} data-id="element-25" />
          </Routes>
          {showUpdatesDialog && <UpdatesDialog onClose={handleCloseUpdatesDialog} data-id="element-27" />}
        </div>
      </BrowserRouter>
    </ErrorBoundary>;
}